import React, { useState, useEffect } from 'react';
import bannerImage from '../../assets/exterior/vasudharinihomes_exterior_1.png';

const Hero = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  
  // Add parallax effect on scroll
  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative w-full h-[90svh] overflow-hidden">
      {/* Banner image with parallax effect */}
      <div 
        className="absolute inset-0 bg-cover bg-center transform scale-110"
        style={{ 
          backgroundImage: `url(${bannerImage})`, 
          transform: `translateY(${scrollPosition * 0.15}px) scale(1.1)`,
          transition: 'transform 0.1s ease-out'
        }}
      />
      
      {/* Gradient overlay for better text visibility */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 sm:from-black/70 to-transparent" />

      {/* Content container with responsive padding */}
      <div className="relative h-full container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col justify-end h-full pb-1">
          <div className="max-w-3xl">
            {/* Animated reveal on load */}
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-medium text-white mb-4 animate-fade-in">
              Creating Affordable Luxury Homes
            </h1>
            
            <p className="text-base md:text-xl text-white mb-8 max-w-2xl animate-fade-in">
              Vasudharini Nest - Spanish architecture meets modern living in Sarjapur, Bengaluru
            </p>
            
            {/* <div className="flex flex-col sm:flex-row gap-4">
              <button className="bg-yellow-500 hover:bg-yellow-600 text-black font-medium py-3 px-6 rounded-md transition duration-300 text-sm md:text-base">
                Explore Project
              </button>
              <button className="bg-transparent hover:bg-white/10 text-white border border-white py-3 px-6 rounded-md transition duration-300 text-sm md:text-base">
                Book a Site Visit
              </button>
            </div> */}
          </div>
        </div>
      </div>
      
      {/* Decorative element - scroll indicator */}
      {/* <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 hidden md:flex flex-col items-center animate-bounce">
        <span className="text-white text-sm mb-2">Scroll to explore</span>
        <svg className="w-6 h-6 text-white" fill="none" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
          <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
        </svg>
      </div> */}
    </div>
  );
};

export default Hero;